import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { buildLoginRedirectPath } from '../../services/ApolloClient/authErrorHandling';

type RequireAuthProps = {
  children?: React.ReactElement;
};

const RequireAuth = ({ children }: RequireAuthProps) => {
  const { signed } = useAuth();
  const location = useLocation();

  if (signed === null) {
    return null;
  }

  if (!signed) {
    return <Navigate to={buildLoginRedirectPath(location.pathname, location.search)} replace />;
  }

  return children ?? <Outlet />;
};

export default RequireAuth;
